import { Tag } from '../Tag';

import { getStatusTitle } from './getStatusTitle';

const getIntent = (onlineStatus: string) => {
  switch (onlineStatus) {
    case 'online':
      return 'success';
    case 'busy':
      return 'warning';
    case 'offline':
    default:
      return 'default';
  }
};

const StatusTag = ({ status }: { status: 'online' | 'busy' | 'offline' }) => {
  const intent = getIntent(status);
  const title = getStatusTitle(status);

  return <Tag intent={intent}>{title}</Tag>;
};

export { StatusTag };
